/* ==========================================================================
   CSA Main Product JavaScript
   Gallery Syncing (Main Swiper + 4-Thumbnail Swiper + Outer Arrows)
   Full Shopify Theme Editor Realtime Sync & Lifecycle Management
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initCSAMainProductSections();
});

/* Realtime Shopify Theme Editor Lifecycle Listeners */
document.addEventListener('shopify:section:load', function (event) {
  if (event.target.classList.contains('section-csa-main-product') || event.target.querySelector('.csa-swiper-main')) {
    initCSAMainProductSection(event.target);
  }
});

document.addEventListener('shopify:section:unload', function (event) {
  if (event.target.classList.contains('section-csa-main-product') || event.target.querySelector('.csa-swiper-main')) {
    destroyCSAMainProductSection(event.target);
  }
});

document.addEventListener('shopify:block:select', function (event) {
  const blockEl = event.target;
  const sectionEl = blockEl.closest('.csa-product-section');
  if (sectionEl) {
    const mainSwiperEl = sectionEl.querySelector('.csa-swiper-main');
    if (mainSwiperEl && mainSwiperEl.swiperInstance) {
      mainSwiperEl.swiperInstance.update();
    }
  }
});

function destroyCSAMainProductSection(section) {
  const mainSwiperEl = section.querySelector('.csa-swiper-main');
  const thumbsSwiperEl = section.querySelector('.csa-swiper-thumbs');

  if (thumbsSwiperEl && thumbsSwiperEl.swiperInstance) {
    thumbsSwiperEl.swiperInstance.destroy(true, true);
    thumbsSwiperEl.swiperInstance = null;
  }
  if (mainSwiperEl && mainSwiperEl.swiperInstance) {
    mainSwiperEl.swiperInstance.destroy(true, true);
    mainSwiperEl.swiperInstance = null;
  }
}

function initCSAMainProductSections() {
  const sections = document.querySelectorAll('.csa-product-section');
  sections.forEach(function (section) {
    initCSAMainProductSection(section);
  });
}

function initCSAMainProductSection(section) {
  const mainSwiperEl = section.querySelector('.csa-swiper-main');
  const thumbsSwiperEl = section.querySelector('.csa-swiper-thumbs');

  if (!mainSwiperEl) return;

  // Clean up any existing instances
  destroyCSAMainProductSection(section);

  if (typeof Swiper === 'undefined') return;

  // 1. Initialize Thumbnail Swiper (4 visible thumbs on desktop)
  let thumbsSwiper = null;
  if (thumbsSwiperEl) {
    const prevBtn = section.querySelector('.csa-thumb-prev');
    const nextBtn = section.querySelector('.csa-thumb-next');

    thumbsSwiper = new Swiper(thumbsSwiperEl, {
      slidesPerView: 4,
      spaceBetween: 8,
      freeMode: false,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      resizeObserver: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

    thumbsSwiperEl.swiperInstance = thumbsSwiper;
  }

  // 2. Initialize Main Gallery Swiper
  const mainSwiper = new Swiper(mainSwiperEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    resizeObserver: true,
    thumbs: {
      swiper: thumbsSwiper,
    },
  });

  mainSwiperEl.swiperInstance = mainSwiper;

  // Mobile counter controls
  const mobilePrev = section.querySelector('.csa-counter-prev');
  const mobileNext = section.querySelector('.csa-counter-next');
  const currentBadge = section.querySelector('.csa-counter-current');

  if (mobilePrev) {
    mobilePrev.addEventListener('click', function () {
      mainSwiper.slidePrev();
    });
  }
  if (mobileNext) {
    mobileNext.addEventListener('click', function () {
      mainSwiper.slideNext();
    });
  }

  mainSwiper.on('slideChange', function () {
    if (currentBadge) {
      currentBadge.textContent = mainSwiper.realIndex + 1;
    }
  });

  // Handle Tab Buttons inside Product Tabs block
  initTabs(section);

  // Handle Dynamic Shipping Date
  initDynamicShippingDate(section);

  // Handle Variant Change Listener
  initVariantChangeListener(section, mainSwiper);

  // Trigger delayed update for smooth image height calculations
  setTimeout(function () {
    if (mainSwiper && !mainSwiper.destroyed) mainSwiper.update();
    if (thumbsSwiper && !thumbsSwiper.destroyed) thumbsSwiper.update();
  }, 120);
}

/* Tabs Switching Handler */
function initTabs(container) {
  const tabBtns = container.querySelectorAll('.csa-tab-btn');
  const tabPanes = container.querySelectorAll('.csa-tab-pane');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const targetTab = btn.getAttribute('data-tab');

      tabBtns.forEach((b) => b.classList.remove('active'));
      tabPanes.forEach((p) => p.classList.remove('active'));

      btn.classList.add('active');
      const targetPane = container.querySelector('#csa-tab-pane-' + targetTab);
      if (targetPane) {
        targetPane.classList.add('active');
      }
    });
  });
}

/* Dynamic Shipping Date Calculation (e.g. Fri Jul 24) */
function initDynamicShippingDate(container) {
  const autoDateElements = container.querySelectorAll('[data-auto-date="true"]');
  if (autoDateElements.length === 0) return;

  const targetDate = new Date();
  targetDate.setDate(targetDate.getDate() + 2); // 2 days from today

  const options = { weekday: 'short', month: 'short', day: 'numeric' };
  const formattedDate = targetDate.toLocaleDateString('en-US', options);

  autoDateElements.forEach(function (el) {
    el.textContent = formattedDate;
  });
}

/* Variant Change Handler: Auto-slide gallery to variant featured image */
function initVariantChangeListener(container, mainSwiper) {
  container.addEventListener('change', function (event) {
    if (event.target.matches('variant-selects select, variant-radios input')) {
      setTimeout(function () {
        const selectedVariantInput = container.querySelector('product-form input[name="id"]');
        if (!selectedVariantInput) return;

        const variantId = selectedVariantInput.value;
        const matchingSlide = container.querySelector(`.swiper-slide[data-variant-id="${variantId}"]`);

        if (matchingSlide && mainSwiper) {
          const slideIndex = Array.from(matchingSlide.parentNode.children).indexOf(matchingSlide);
          if (slideIndex !== -1) {
            mainSwiper.slideTo(slideIndex);
          }
        }
      }, 150);
    }
  });
}
